import { ds } from "js/core/models/dataService";
import { SideBar } from "js/editor/ui";
import { AnimationPanel, AnimationPanelTabType } from "js/react/views/AnimationPanel/AnimationPanel";
import renderReactRoot from "js/react/renderReactRoot";
import { SideBarCanvasModifier } from "common/constants";

export const EditorAnimationPanel = SideBar.extend({
    className: "editor_menu animation-panel",

    type: "AnimationPanel",
    preventCanvasEditingWhenOpen: false,

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    setup: function({ editor, showAudio, isReadOnly = false }) {
        this.showAudio = showAudio;
        if (this.showAudio) {
            this.type = "AudioPanel";
        }
        this.isReadOnly = isReadOnly;
        this.editor = editor;

        this.editor.on("setCurrentCanvas", () => {
            this.renderAnimationPanel();
        });
    },

    renderContents: function() {
        this.renderAnimationPanel();
    },

    renderAnimationPanel: function() {
        if (this.unmountAnimationPanel) {
            this.unmountAnimationPanel();
            this.unmountAnimationPanel = null;
        }

        this.unmountAnimationPanel = renderReactRoot(
            AnimationPanel,
            {
                tab: this.showAudio ? AnimationPanelTabType.AUDIO : AnimationPanelTabType.ANIMATION,
                canvas: this.editor.currentCanvas,
                isReadOnly: this.isReadOnly,
                dialogHeight: 200,
                onClose: () => this.close()
            },
            this.$el[0]
        );
    },

    cleanUp: function() {
        if (this.unmountAnimationPanel) {
            this.unmountAnimationPanel();
            this.unmountAnimationPanel = null;
        }

        this.editor.off("setCurrentCanvas");
    }
});
